import {Component, Input} from '@angular/core';

import {DetailField, DetailParams} from '../../../../shared';
import {REGIONALESCOREDETAIL_DEFAULT_FIELDS, RegionalesCoreDetailParams} from '../../../models';

@Component({
  selector: 'app-regional-detail',
  templateUrl: './regional-detail.component.html',
  styleUrls: ['./regional-detail.component.scss']
})
export class RegionalDetailComponent {
  fields: DetailField[] = [];
  detailParams: DetailParams = null;

  constructor() {
  }

  _params: RegionalesCoreDetailParams = null;

  @Input()
  set params(value: RegionalesCoreDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }

    this.fields = value.fields || REGIONALESCOREDETAIL_DEFAULT_FIELDS;

    const rows = this.fields
      .map(f => ({
        label: f.label,
        value: value.regional[f.name]
      }));
    this.detailParams = {
      rows
    };
  }
}
